(function() {
'use strict';

window.DD_RUM && window.DD_RUM.onReady(() => {
    let ver = TRPCONFIG.CurrentVersion;
    ver = ver.split('_');
    let currentVersion = ver[0];

    window.DD_RUM.init({
        applicationId: TRPCONFIG.Domain2.DataDogApplicationId,
        clientToken: TRPCONFIG.Domain2.DataDogClientToken,
        site: 'datadoghq.com',
        sessionSampleRate: TRPCONFIG.Domain2.DataDogSessionSampleRate,
        sessionReplaySampleRate: TRPCONFIG.Domain2.DataDogSessionReplaySampleRate,
        trackResources: TRPCONFIG.Domain2.DataDogTrackResources,
        trackUserInteractions: TRPCONFIG.Domain2.DataDogTrackUserInteractions,
        trackLongTasks: TRPCONFIG.Domain2.DataDogTrackLongTasks,
        service: 'emirates-holidays-v2',
        allowedTracingUrls: [
            /https:\/\/.*\.dnatatravel-services\.com/,
            /https:\/\/.*\.emiratesholidays\.com/,
            /https:\/\/.*\.emiratesholidays\.digital/,
            /https:\/\/.*\.emiratesvacations\.com/,
        ],
        defaultPrivacyLevel: 'mask-user-input',
        env: TRPCONFIG.Domain2.DataDogEnvironment,
        version: currentVersion,
        datacenter: TRPCONFIG.Domain2.DataDogDatacenter,
    });
});


function changeCookiesState(state) {
    if (window.TRPCONFIG === undefined) {
        window.TRPCONFIG = { Domain: {}, Domain2: {} };
    }
    TRPCONFIG.Domain.ShortlistsEnabled = TRPCONFIG.Domain.ShortlistsEnabled && state;
    TRPCONFIG.EnableSavedSearches = TRPCONFIG.EnableSavedSearches && state;
    TRPCONFIG.PayPalEnabled = state;
    TRPCONFIG.Domain.RecentHotelsEnabled = TRPCONFIG.Domain.RecentHotelsEnabled && state;
    TRPCONFIG.MenuEnabled = state;
    TRPCONFIG.SignInEnabled = state;
    TRPCONFIG.ManageBookingEnabled = state;
}

const cookies = ('cookie' in document && (document.cookie.length > 0 ||
    (document.cookie = 'test').indexOf.call(document.cookie, 'test') > -1));

changeCookiesState(cookies);

const devices = {
    desktop: 'Desktop',
    mobile: 'Mobile'
};

const angularModules = [
    'ngRoute',
    'ngSanitize',
    'ngMessages'
];

// In production this array is replaced by an entry from dep.json during build
const modules = [
    'attractions',
    'carHire',
    'cms',
    'core',
    'dashboard',
    'deals',
    'ekh',
    'flights',
    'insurance',
    'manageBooking',
    'marhaba',
    'parking',
    'products',
    'quote',
    'recommendations',
    'reviews',
    'search',
    'searchUnit',
    'snm',
    'transfers',
    'trp',
    'trustpilot',
    'destinations',
    'deepLink'
];

if ([37, 56, 61, 66, 69].indexOf(TRPCONFIG.Domain.DomainId) > -1) {
    modules.push('ekh');
}

if (TRPCONFIG.Domain.LiveChat && TRPCONFIG.Domain.LiveChat.Enabled) {
    modules.push('liveChatModule');
}

if (TRPCONFIG.Domain.LiveChat && TRPCONFIG.Domain.LiveChat.SnapInEnabled) {
    modules.push('liveChatSnapInModule');
}

if (TRPCONFIG.Domain.DomainId === 60) {
    modules.push('snm');
}

modules.push('dashboard');

if (TRPCONFIG.Domain.QuoteEnabled) {
    modules.push('quote');
}

if (TRPCONFIG.Domain.MarhabaEnabled) {
    modules.push('marhaba');
}

if (modules.indexOf('travelAgent') < 0) {
    modules.push('travelAgent');
}

for (const i in modules) {
    angular.module(modules[i], ['ngRoute']);
}

//Vendor ones need to stay after our own modules, otherwise they will get initialised wrongly
if (TRPCONFIG.Domain.DeviceType === devices.desktop) {
    modules.push('toaster');
}

angular.module('TR', angularModules.concat(modules));
})();
